





















import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';

export default Vue.component('task-dropdown', {
  name: 'TaskDropdown',
  props: {
    'userId': { type: [Number, String] },
  },
  mixins: [HttpMixin],
  data () {
    return {
      showDropdown: false
    }
  },
  components: {
    VueSimpleSpinner
  },
  computed: {
    title(): string {
      const user = this.users.filter((user: any) => user.appUserId === Number(this.userId)).pop() as any;
      return user ? `${user.firstName}'s Tasks` : 'Tasks';
    },
    users(): any[] {
      return this.$store.state.user.users;
    }
  },
  async created() {
    await this.$store.dispatch('user/loadUsers');
  },
  methods: {
    async toggleDropdown () {
      this.showDropdown = !this.showDropdown;
    },
    updateOwner (user: any) {
      this.$emit('user-selected', user.appUserId);
      this.showDropdown = false;
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/tasks/TaskDropdown.vue